// @flow

import React from 'react';

import {
  InfiniteListFetcher,
  type InfiniteListFetcherProps,
} from 'app/general/datafetchers/InfiniteListFetcher';
import {
  buildMultipleDataFetcher,
  buildSingleDataFetcher,
} from 'app/general/datafetchers/builders';
import {getDenormalizedListFactory} from 'app/utils/redux_v2';

/* users */

import {
  fetchUserList,
  convertLocationParamsToFetchParams as userParamsConverter,
} from 'app/user/actions';
import type {UserType} from 'app/user/types';

const denormalizeUsersList = getDenormalizedListFactory<UserType>((state) =>
  state.userArea.get('usersv2')
);

export const MultipleStoredUsersFetcher = buildMultipleDataFetcher<UserType>(
  userParamsConverter,
  // $FlowFixMe - flow doesn't understand redux-thunk magic
  fetchUserList,
  denormalizeUsersList
);

export const StoredUsersFetcher = buildSingleDataFetcher<UserType>(
  MultipleStoredUsersFetcher
);

export const UsersInfiniteListFetcher = (
  props: InfiniteListFetcherProps<UserType>
) => (
  <InfiniteListFetcher DataFetcher={MultipleStoredUsersFetcher} {...props} />
);

/* invitations */
import {
  fetchInvitations,
  convertInvitationsParamsToQuery,
} from 'app/user/actions';
import type {InvitationType} from 'app/user/types';

const denormalizeInvitationsList = getDenormalizedListFactory<InvitationType>(
  (state) => state.userArea.get('invitations')
);

export const MultipleStoredInvitationsFetcher =
  buildMultipleDataFetcher<InvitationType>(
    convertInvitationsParamsToQuery,
    // $FlowFixMe - flow doesn't understand redux-thunk magic
    fetchInvitations,
    denormalizeInvitationsList
  );

export const StoredInvitationsFetcher = buildSingleDataFetcher<InvitationType>(
  MultipleStoredInvitationsFetcher
);
